import { permissionsRol as contentRol } from 'app/policies/roles/contentsRol.access';
import { PATH_CONTENT, PATH_CONTENTS, PATH_CONTENT_CREATE } from 'app/router/routesConfigContents';

export function contents(path, user) {
  if (PATH_CONTENT === path) {
    return contentRol(user).readDetail;
  }

  if (PATH_CONTENTS === path) {
    return contentRol(user).readList;
  }

  if (PATH_CONTENT_CREATE === path) {
    return contentRol(user).create;
  }

  return true;
}
